import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';
import { FormFeedback, Input } from 'reactstrap';
import { fetchHRCodeList } from '../../../store/apis/commonService';
import { CLAIM_FORM_TYPES } from '../../../pages/ExpenseClaims/Employee/EmployeeExpenseClaim/constants';

export default function DependentElement({
  formMethods,
  name,
  codeType = 'DEPENDENT1',
  formType,
  expenseClaimHeaders = null,
}) {
  const {
    control,
    formState: { errors },
  } = formMethods;

  const { data: dependentOptions = [], refetch: refetchDependentOptions } =
    useQuery({
      queryKey: ['dependentNames', expenseClaimHeaders?.employeeId],
      queryFn: () =>
        fetchHRCodeList({
          type: codeType,
          employeeId: expenseClaimHeaders?.employeeId?.trim() || null,
        }),
      enabled: !!expenseClaimHeaders?.employeeId,
      refetchOnMount: 'always',
    });

  // Refetch whenever component opens/mounts
  useEffect(() => {
    if (refetchDependentOptions) {
      refetchDependentOptions();
    }
  }, [refetchDependentOptions]);

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            type="select"
            name={name}
            className={`form-control external-filter-input ${errors?.[name] ? 'is-invalid' : ''}`}
            disabled={formType === CLAIM_FORM_TYPES.VIEW}
          >
            <option value={Number(-1)}>-- Select Name --</option>
            {dependentOptions.map(dep => (
              <option key={dep.Code} value={Number(dep.Code.trim())}>
                {dep.Description}
              </option>
            ))}
          </Input>
        )}
      />
      {errors?.[name] && <FormFeedback>{errors?.[name]?.message}</FormFeedback>}
    </>
  );
}
